module.exports = __webpack_public_path__ + "img/slogan.44f598e7.svg";